import { PaddedDiv } from 'modules/Roles/Style/style'
import React from 'react'

import styled from 'styled-components'

import Flex from '../../../../../../components/Flex'
import MandatoryIndex from './mandatory'
import { OverViewText } from './style'

const CardRowDiv = styled(Flex)`
  display: flex;
  flex-wrap: nowrap;
  flex-direction: row;

  min-width: 320px;
  gap: 2em;
  margin-bottom: 4em;
  @media (max-width: 768px) {
    flex-direction: row;
  }

  .inline-block-element {
    display: inline-block;
  }
`

const Overviewindex = ({ data, isVisible = false }) => {
  return (
    <>
      {isVisible ? (
        <>
          <PaddedDiv column>
            <OverViewText>
              This doughnut chart illustrates the overall distribution of
              candidates' responses across different score range.
            </OverViewText>
          </PaddedDiv>

          <CardRowDiv>
            <MandatoryIndex chartData={data} />
          </CardRowDiv>
        </>
      ) : (
        <OverViewText
          style={{
            display: 'flex',
            justifyContent: 'center',
            fontWeight: '600',
          }}
        >
          At present, there have been no applicants for this role
        </OverViewText>
      )}
    </>
  )
}

export default Overviewindex
